// AlignUI · иллюстрация пустого состояния: рабочее место: монитор и чашка
//
// Перенесена скриптом из набора дизайн-системы, руками не правится. Цвета заменены на
// семантические классы: под ними лежат переменные `--illustration-*`, у которых в тёмной
// теме своя ступень серого. Без этого картинка светилась бы белым пятном на тёмном экране.

import type { SVGProps } from 'react';

export function IllustrationСпокойно(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 148 149' fill='none' {...props}>
      <rect className='fill-illustration-weak-100' width='148' height='148' rx='74' />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M107.377 40.1585V86.1296H23.9304V40.1585C23.9304 36.3265 27.035 33.2218 30.8671 33.2218H100.44C104.272 33.2218 107.377 36.3265 107.377 40.1585Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        d='M116.041 40.1585V91.923C116.041 95.7549 112.936 98.8594 109.104 98.8594H100.44C104.272 98.8594 107.377 95.7549 107.377 91.923V40.1585C107.377 36.3265 104.272 33.2218 100.44 33.2218H109.104C112.936 33.2218 116.041 36.3265 116.041 40.1585Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M107.373 86.1237V91.9204C107.373 95.7572 104.277 98.8546 100.439 98.8546H30.8659C27.0288 98.8546 23.9317 95.7572 23.9317 91.9204V86.1237H107.373Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path className='fill-illustration-white-0' d='M44.9119 114.778H49.2148H53.8604' />
      <path
        className='stroke-illustration-strong-400'
        d='M44.9119 114.778H49.2148H53.8604'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M77.2119 114.778H53.8608C58.0949 114.778 61.0687 110.598 59.6849 106.597L57.0261 98.8545H80.3772L83.036 106.597C84.4198 110.598 81.4461 114.778 77.2119 114.778Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M53.8606 114.778H49.215'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M98.8016 107.653H98.3451C88.8468 107.653 81.1353 99.942 81.1353 90.4436V81.6459H116.011V90.4436C116.011 99.942 108.3 107.653 98.8016 107.653Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M113.103 100.512H117.054C120.928 100.512 124.069 97.3713 124.069 93.4972C124.069 90.3286 121.968 87.6507 119.083 86.7805'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        d='M116.474 114.778H80.672C78.1907 114.778 76.1762 112.764 76.1762 110.282H120.97C120.97 112.764 118.956 114.778 116.474 114.778Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-sub-300'
        d='M42.1773 63.1396H34.0308C33.2739 63.1396 32.6604 63.7531 32.6604 64.51V72.6565C32.6604 73.4134 33.2739 74.0269 34.0308 74.0269H42.1773C42.9342 74.0269 43.5477 73.4134 43.5477 72.6565V64.51C43.5477 63.7531 42.9342 63.1396 42.1773 63.1396Z'
      />
      <path
        className='fill-illustration-soft-200'
        d='M71.8417 42.8494H63.6951C62.9383 42.8494 62.3248 43.4629 62.3248 44.2197V52.3663C62.3248 53.1231 62.9383 53.7367 63.6951 53.7367H71.8417C72.5985 53.7367 73.2121 53.1231 73.2121 52.3663V44.2197C73.2121 43.4629 72.5985 42.8494 71.8417 42.8494Z'
      />
      <path
        className='fill-illustration-sub-300'
        d='M98.8156 65.317H52.5716C51.8148 65.317 51.2012 65.9305 51.2012 66.6873V69.2199C51.2012 69.9767 51.8148 70.5903 52.5716 70.5903H98.8156C99.5724 70.5903 100.186 69.9767 100.186 69.2199V66.6873C100.186 65.9305 99.5724 65.317 98.8156 65.317Z'
      />
      <path
        className='fill-illustration-sub-300'
        d='M99.5007 45.8965H82.236C81.4791 45.8965 80.8656 46.51 80.8656 47.2669V49.7994C80.8656 50.5563 81.4791 51.1698 82.236 51.1698H99.5007C100.258 51.1698 100.871 50.5563 100.871 49.7994V47.2669C100.871 46.51 100.258 45.8965 99.5007 45.8965Z'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M33.068 48.293C33.068 48.293 37.4591 53.4977 42.3546 53.4977C47.2501 53.4977 51.4038 48.293 51.4038 48.293C51.4038 48.293 47.2501 43.0883 42.3546 43.0883C37.4591 43.0883 33.068 48.293 33.068 48.293Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-strong-400 stroke-illustration-strong-400'
        d='M42.29 51.908C44.2566 51.908 45.8508 50.3138 45.8508 48.3472C45.8508 46.3807 44.2566 44.7865 42.29 44.7865C40.3235 44.7865 38.7292 46.3807 38.7292 48.3472C38.7292 50.3138 40.3235 51.908 42.29 51.908Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M44.6775 3.0001C44.6775 3.0001 39.3054 9.30245 45.5679 14.6775C39.3053 9.30234 33.8905 15.5679 33.8905 15.5679C33.8905 15.5679 39.2626 9.26557 33 3.89036C39.2626 9.26557 44.6775 3.0001 44.6775 3.0001Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M115.514 138.628C115.514 138.628 107.259 139.286 107.887 147.515C107.259 139.285 99 139.887 99 139.887C99 139.887 107.255 139.229 106.628 131C107.255 139.229 115.514 138.628 115.514 138.628Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
